package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class SavedCellFill(
    val row: Int,
    val col: Int,
    val letter: String,
    val status: String,
)

@Serializable
data class SavedPuzzleSession(
    val puzzleId: String,
    val puzzleLabel: String,
    val isDaily: Boolean = false,
    val dailyDateIso: String = "",
    val fromChallenge: Boolean = false,
    val challengerName: String = "",
    val challengerTimeMs: Long = 0,
    val elapsedMs: Long = 0,
    /** Still written for older builds reading this blob; [percentComplete] goes by [fills] instead. */
    val filledCount: Int = 0,
    /** Squares the player has to fill -- starter letters excluded (older saves included them). */
    val totalCells: Int = 1,
    val hintsUsed: Int = 0,
    val lettersRevealed: Int = 0,
    val mistakes: Int = 0,
    val selectedRow: Int? = null,
    val selectedCol: Int? = null,
    val direction: String = "ACROSS",
    val fills: List<SavedCellFill> = emptyList(),
) {
    /**
     * Counted from [fills] -- the player's own letters, never starter letters -- rather than
     * [filledCount], which older builds inflated with the starters. So a save made before the fix
     * reads right too (at worst a little low, since its [totalCells] still includes starters).
     */
    val percentComplete: Int
        get() = if (totalCells <= 0) 0 else ((fills.size * 100) / totalCells).coerceIn(0, 100)

    /** Whether there is anything to resume. Older builds saved untouched puzzles too. */
    val hasPlayerInput: Boolean
        get() = fills.isNotEmpty() || hintsUsed > 0 || lettersRevealed > 0
}
